import React, { useState } from "react";
import PropTypes from "prop-types";
import Loader from 'components/general/Loader'
import { useSelector, useDispatch } from 'react-redux'
import { componentIntermediateSelector } from 'state-management/actions'
import Label, { useLabels } from "components/general/Label";
import Sprites from "styles/images/SpriteIcons.svg";


import {
  useTable,
  useSortBy,
  useGlobalFilter,
  useFilters,
  useResizeColumns,
  usePagination,
  useExpanded,
  useRowState
} from "react-table";
import {
  Table,
  Row,
  Col,
  InputGroup,
  FormControl,
  Button,
  Container

} from "react-bootstrap";

import GlobalFilter from "./GlobalFilter";
import ColumnFilter from "./ColumnFilter";
import useViewport from "../useViewPort";
import { defaultIntermediate } from "state-management/reducers";
import { useDispatchLegends } from "components/common/legendContext";
import SvgMirs from "components/presentation/SvgMirs";


function useInstance(instance) {
  const { allColumns } = instance;
  let rowSpanHeaders = [];
  allColumns.forEach((column, i) => {
    const { id, enableRowSpan } = column;
    if (enableRowSpan === true || id === "Expander") {
      rowSpanHeaders = [
        ...rowSpanHeaders,
        { id, topCellValue: null, topCellIndex: 0 }
      ];
    }
  });

  Object.assign(instance, { rowSpanHeaders });
}

const NavbarSplits = ({ columnIndex, setColumnIndex, numColumns, numExtendedColsVisible, hasTimeline, rscId }) => {
  const fLabel = useLabels()
  const intermediateSelectorState = useSelector((state) => state.appGlobal.intermediateSelector)
  let intermediateSelectorRedux = Object.assign({}, intermediateSelectorState.find(item => item.rsc === rscId));
  const dispatch = useDispatch();
  //if (!show) return null
  let index = Number(columnIndex);
  let blocksColumns = [];
  if (isNaN(numExtendedColsVisible) && String(numExtendedColsVisible).includes(",")) {
    blocksColumns = numExtendedColsVisible.split(',');
  }

  const handleColumnIncrement = () => {
    //Show hide columns by blocks numColumns.includes(",")
    if (isNaN(numExtendedColsVisible) && String(numExtendedColsVisible).includes(",")) {
      index = (index < blocksColumns.length) ? index + 1 : index
    } else {
      index = (index < numColumns) ? index + 1 : index;
    }
    setColumnIndex(index)
    hasTimeline && updateReduxData(index)

  }
  const handleColumnDecrement = () => {

    if (isNaN(numExtendedColsVisible) && String(numExtendedColsVisible).includes(",")) {
      index = (index > 1) ? index - 1 : 1;
    } else {
      index = index > numExtendedColsVisible ? index - 1 : numExtendedColsVisible;
    }
    setColumnIndex(index)
    hasTimeline && updateReduxData(index)
  }


  const updateReduxData = (index) => {
    let intermediateSelector = Object.assign({}, intermediateSelectorRedux ? intermediateSelectorRedux : defaultIntermediate);
    intermediateSelector.selected = index;
    intermediateSelector.isLive = false
    intermediateSelector.action = "Dispatch from Table"

    dispatch(componentIntermediateSelector(intermediateSelector))
  }

  return (
    <nav id="TableShowColumns" aria-labelledby="NavScheduleNavigation" >
      <span id="NavScheduleNavigation" className="d-none"><Label data="LabelCompScheduleNav" /></span>
      <button className='next-arrow' aria-label={fLabel({ data: "HeaderShowPreviousColumns" })} onClick={() => handleColumnDecrement()}><SvgMirs className="mirsIcon" code='arrowLeft' insideBtn={true} /></button>
      &nbsp;{/*<span>{index}/{columnIndex}/{blocksColumns.length}</span>*/}
      <button className='next-arrow' aria-label={<Label data="HeaderShowNextColumns" />} onClick={() => handleColumnIncrement()}><SvgMirs className="mirsIcon" code='arrowRight' insideBtn={true} /></button>
    </nav>
  );
};

// Create a default prop getter
const defaultPropGetter = () => ({})

const MirsTable = ({
  ariaLabelledby,
  columns: userColumns,

  data,
  //expandRows,
  //expandedRowObj,
  keyRow,
  hiddenColumns,
  colIndex,
  colsExtendedVisible,
  hasRelatedTimeline,
  caption,
  classCaption,
  className,
  discipline,
  expandedAll,
  extendedComponents,
  footerData,
  initialSortBy,
  id,
  //containerColumnClassName,
  getHeaderProps = defaultPropGetter,
  getColumnProps = defaultPropGetter,
  getRowProps = defaultPropGetter,
  getCellProps = defaultPropGetter,
  pageSizeCustom,
  renderRowSubComponent,
  rowOnClick,
  rowClickHandler,
  rscId,
  showNavExtendedData,
  showLoading,
  showPagination,
  sortCallBack,
  sortable = true,
  showGlobalFilter,
  theadClassName,
  tbodyClassName,
  summaryDesc,

}) => {
  const [columnIndex, setColumnIndex] = useState(colIndex === undefined ? 1 : colIndex)
  const [numExtendedColsVisible, setNumExtendedColsVisible] = useState(colsExtendedVisible === undefined ? 1 : colsExtendedVisible)
  const [numExtendedColsVisibleChange, setNumExtendedColsVisibleChange] = useState(false)
  const [expandedElements, setExpandedElements] = useState([]);
  const [expandedAllElements, setExpandedAllElements] = useState(false);


  //const [hasTimeline, sethasTimeline] = useState(hasRelatedTimeline === undefined ? false : hasRelatedTimeline)
  const hasTimeline = hasRelatedTimeline === undefined ? false : hasRelatedTimeline;

  const [showNavExtendedDataInternal, setShowNavExtendedDataInternal] = useState(showNavExtendedData === undefined ? false : showNavExtendedData)
  //const [showLoadingInternal, setShowLoadingInternal] = useState(showLoading === undefined ? false : showLoading)
  const showLoadingInternal = showLoading === undefined ? false : showLoading;
  const [tableLoading, setTableLoading] = useState(false);
  const intermediateSelectorState = useSelector((state) => state.appGlobal.intermediateSelector)
  const intermediate = intermediateSelectorState.find(item => item.rsc === rscId)
  let intermediateSelectorRedux = Object.assign({}, intermediate ? intermediate : defaultIntermediate);
  const { breakPoint } = useViewport();
  const isMobile = breakPoint === "sm" || breakPoint === "xs"
  const filterTypes = React.useMemo(
    () => ({
      includes: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
              .toLowerCase()
              .includes(String(filterValue).toLowerCase())
            : true;
        });
      },

      startsWith: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase())
            : true;
        });
      }
    }),
    []
  );

  const sortTypes = React.useMemo(
    () => ({
      dateSort: (a, b) => {
        a = new Date(a).getTime();
        b = new Date(b).getTime();
        return b > a ? 1 : -1;
      },
      absoluteOrderNumber(rowA, rowB, columnId, desc) {
        let a = (typeof (rowA.values[columnId]) === 'string' || rowA.values[columnId] instanceof String) ? rowA.values[columnId].trim() : rowA.values[columnId]
        let b = (typeof (rowB.values[columnId]) === 'string' || rowB.values[columnId] instanceof String) ? rowB.values[columnId].trim() : rowB.values[columnId]

        if ((a === null || a === '') && (b !== null || b !== '')) {
          return desc ? -1 : 1;
        }

        if ((a !== null || a !== '') && (b === null || b === '')) {
          return desc ? 1 : -1;
        }

        if ((a === null || a === '') && (b === null || b === '')) {
          return 0;
        }
        return a - b
      },
      absoluteOrderString(rowA, rowB, columnId, desc) {
        let a = (typeof (rowA.values[columnId]) === 'string' || rowA.values[columnId] instanceof String) ? rowA.values[columnId].trim() : rowA.values[columnId]
        let b = (typeof (rowB.values[columnId]) === 'string' || rowB.values[columnId] instanceof String) ? rowB.values[columnId].trim() : rowB.values[columnId]

        if ((a === null || a === '') && (b !== null || b !== '')) {
          return desc ? -1 : 1;
        }

        if ((a !== null || a !== '') && (b === null || b === '')) {
          return desc ? 1 : -1;
        }

        if ((a === null || a === '') && (b === null || b === '')) {
          return 0;
        }
        return a?.toString()?.toLowerCase().localeCompare(b?.toString()?.toLowerCase())
      },

    }),
    []
  );

  const defaultColumn = React.useMemo(
    () => ({
      Filter: ColumnFilter,
      disableFilters: true,
      minWidth: 30,
      width: 150,
      maxWidth: 500,
      disableSortBy: true,
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    rows, //rows return all rows 
    page, //has only the rows for the active page

    setGlobalFilter,
    rowSpanHeaders,
    setHiddenColumns,
    setSortBy,
    //Pagination elements  
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { globalFilter, pageIndex, pageSize, sortBy }
  } = useTable(
    {
      columns: userColumns,
      data,
      initialState: {
        pageSize: pageSizeCustom,
        sortBy: initialSortBy,
        /*
         expanded:
             expandRows && expandedRowObj.hasOwnProperty(0) ? expandedRowObj : {},
         */
        //hiddenColumns: hiddenColumns //initialize hide columns id

        hiddenColumns: [...hiddenColumns, ...userColumns
          .filter(col => col.isVisible === false && col.hasOwnProperty('columnIndex'))
          .map(col => col.id)]
      },
      defaultColumn,
      filterTypes,
      sortTypes,
      autoResetRowState: false,
      autoResetSortBy: false,
      autoResetExpanded: false,
      //getResetExpandedDeps: false
      disableSortRemove: true,
      disableSortBy: isMobile ? true : !sortable
    },
    //Rowspan
    hooks => { hooks.useInstance.push(useInstance); },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useResizeColumns,
    useExpanded,
    useRowState,
    showPagination ? usePagination : ''
    //useFlexLayout
  );


  const obj = showPagination ? page : rows;
  const dispatchLegends = useDispatchLegends() ?? null;

  React.useEffect(() => {
    if (expandedAll) {
      handleClickAllExpanded(obj)
    } else {
      setExpandedElements([])
      setExpandedAllElements(false)
    }
  }, [expandedAll])

  //Forzamos cuando cambiamos solo las columnas a cambiar la ordenacion
  // si no ponemos esto la inicializacion de la tabla coge el valor de ordenacion por defecto pero cuando se cambia ese valor inicial no fuerza la reordenacion
  React.useEffect(() => {
    setSortBy(initialSortBy)
  }, [initialSortBy, setSortBy])

  React.useEffect(() => {
    //console.log("Table UsseEfect When Selected Change ", intermediateSelectorRedux)
    if (hasTimeline && intermediateSelectorRedux.selected) {
      let currentSplit =
        ((intermediateSelectorRedux.selected) === 'F')
          ? intermediateSelectorRedux.finalPosition
          : intermediateSelectorRedux.selected
      currentSplit = currentSplit < intermediateSelectorRedux.extendedColsVisibles ? intermediateSelectorRedux.extendedColsVisibles : currentSplit
      setColumnIndex(currentSplit)

    } else {
      //Revisar es necesario????
      //colIndex = colIndex === undefined ? 1 : colIndex
      colIndex = colIndex < numExtendedColsVisible ? numExtendedColsVisible : colIndex
      colIndex = colIndex ? colIndex : numExtendedColsVisible
      setColumnIndex(colIndex)
    }

  }, [colIndex, numExtendedColsVisibleChange, hasTimeline, intermediateSelectorRedux.selected])

  React.useEffect(() => {
    if (hasTimeline && intermediateSelectorRedux.extendedColsVisibles) {
      setNumExtendedColsVisible(intermediateSelectorRedux.extendedColsVisibles)
    } else {
      setNumExtendedColsVisible(colsExtendedVisible)
      //setColumnIndex(colIndex);
    }
    setNumExtendedColsVisibleChange(!numExtendedColsVisibleChange)//Force sow/hide columns  when numExtendedColsVisibles Change 
  }, [colsExtendedVisible, hasTimeline, intermediateSelectorRedux.extendedColsVisibles])

  //useEffect when userColumns Change show Loading 
  React.useEffect(() => {
    setTableLoading(showLoadingInternal);
    const timer = setTimeout(() => {
      setTableLoading(false);
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [userColumns]);

  //Hide columns Splits + hiddenColumns +columns isVisible=false
  React.useEffect(() => {
    let blocksColumns = [];
    let ini = 1;
    let fin = 0;

    let colSplits = userColumns.filter(cell => (cell.hasOwnProperty('columnIndex'))).length;
    if (
      ((!isNaN(numExtendedColsVisible) && (colSplits > 0)) && (colSplits > numExtendedColsVisible))
      || ((isNaN(numExtendedColsVisible)) && (String(numExtendedColsVisible).includes(",")))) {
      setShowNavExtendedDataInternal(true)
    } else {
      setShowNavExtendedDataInternal(false)
    }


    if (isNaN(numExtendedColsVisible) && String(numExtendedColsVisible).includes(",")) {
      blocksColumns = numExtendedColsVisible.split(',');
      if (columnIndex === 1) {
        ini = 1;
      } else {
        for (let i = 0; i < columnIndex - 1; i++) {
          ini += Number(blocksColumns[i])
        }
      }
      fin = (ini + Number(blocksColumns[columnIndex - 1])) - 1;

    }

    //Ponemos todas las columnas en un array, 
    //cuando tienen span hay que buscar en las columnas agrupadas las columnas hijas,
    //sino solo devuelve como columnas las que estan en la fila 1
    let realColumns = [];
    userColumns.forEach(cell => {
      if (cell?.columns) {
        realColumns = [...realColumns, ...cell.columns]
      } else {
        realColumns.push(cell);
      }
    })

    let hiddenCols = [...hiddenColumns,
    ...realColumns.filter(cell =>
      (cell.isVisible === false && !cell.hasOwnProperty('columnIndex')) || (blocksColumns.length > 0)
        ? (cell.isVisible === false && cell.columnIndex < ini) || (cell.columnIndex > fin)
        : (cell.isVisible === false) && (cell.columnIndex < Number(columnIndex) - (numExtendedColsVisible - 1) || cell.columnIndex > Number(columnIndex))
    ).map(cell => {
      return cell.id
    })
    ];

    if (!numExtendedColsVisible && !blocksColumns.length > 0) {
      //Remove all extended columns if not has numExtendedColsVisible
      hiddenCols = [...hiddenColumns,
      ...realColumns.filter(cell =>
        (cell.isVisible === false && cell.hasOwnProperty('columnIndex'))
      ).map(cell => {
        return cell.id
      })
      ];

    }


    setHiddenColumns(hiddenCols)

  }, [columnIndex, hiddenColumns, numExtendedColsVisible, userColumns]
  );

  if (tableLoading) { return <Loader />; }


  function getJsonData(key, i, row) {
    try {
      if (key !== undefined && key !== '') {
        return key.split('-').reduce((a, i) => a[i], row.original);
      } else {
        return id + "_" + i;
      }
    } catch (error) {
      return (id + "_" + i)
    }
  }

  //Calculo de numero de columnas    
  let _colNums = 0;
  userColumns.forEach(col => {
    if (col?.columns) {
      _colNums = _colNums + col?.columns.length;
    } else {
      _colNums = _colNums + 1;
    }
  })

  //Funcion store selected element expanded 
  const handleClickExpanded = (id, cell, obj) => {

    let elements = [...expandedElements]
    let sw = true;
    const split = id.split('~')
    let element
    if (split.length > 1) {
      element = split[0] + "~" + cell.rowSpan
    } else {
      element = split[0]
    }
    if (expandedElements.includes(element)) {
      elements = elements.filter(item => item !== element)
    } else {
      elements.push(element)
    }
    setExpandedElements(elements)

    //Legends open 
    if (dispatchLegends) {
      const payload = elements
      dispatchLegends({
        type: 'expandedElementsTable',
        payload: payload
      })
    }


    //Comprobamos si estan todos seleccionados
    obj.map((row, i) => {
      const id = getJsonData(keyRow, i, row) !== undefined ? getJsonData(keyRow, i, row) : keyRow + '_' + i
      const split = id.split('~')
      let element
      if (split.length > 1) {
        element = split[0] + "~" + cell.rowSpan
      } else {
        element = split[0]
      }
      sw = sw && elements.includes(element)
      //row.isExpanded = elements.includes(element)
    })

    if (sw) {

      setExpandedAllElements(true)
    } else {
      setExpandedAllElements(false)
    }

  }

  const handleClickAllExpanded = (obj) => {

    let elements = []
    if (!expandedAllElements) {
      obj.map((row, i) => {
        const id = getJsonData(keyRow, i, row) !== undefined ? getJsonData(keyRow, i, row) : keyRow + '_' + i
        const cell = row.cells.find(cell => cell.column.id === 'Expander')
        const split = id.split('~')
        let element

        if (split.length > 1) {
          if (cell.rowSpan) { element = split[0] + "~" + cell.rowSpan }

        } else {
          element = split[0]
        }

        if (elements.includes(element)) {
          elements = elements.filter(item => item !== element)
          //row.isExpanded = true;
        } else {
          elements.push(element)
          //row.isExpanded = false;
        }

      })
      setExpandedElements(elements)

    } else {

      setExpandedElements([])
    }
    setExpandedAllElements(!expandedAllElements)

  }

  //This field is used whe make sort associates rows don´t change for example
  // athlete1 stage1
  // athlete1 stage2
  // athlete2 stage1
  // athlete2 stage2
  //sort by athlete but stage1 allways is the firt row in  athlete

  const renderFooterCellContent = (column) => {
    const columnCalculation = footerData.find(
      (calculation) => calculation.id === column.id
    );

    if (columnCalculation) {
      return `${columnCalculation.calculate(data)}`;
    }

    const valueForColumn = data
      .map((row) => row[column.id])
      .reduce((total, value) => total + (value || 0), 0);

    return `${valueForColumn}`;
  };

  let hasKeyIndex = false;
  //First Row in rowspan can have information diferent than the others Team-athletes
  let indexMainRow
  let hasGrouped = false;
  let lastGrouped = ''
  let rowBlockId = 0

  /* Comprobamos que exista la columna KeyIndex necesaria para hacer los rowspan en el body, es por la columna que se mantendra ese orden dentro de un Rowspan*/
  hasKeyIndex = userColumns.find((column) => column?.id === "KeyIndex" || column?.relatedId === "KeyIndex") ? true : false
  //hasGrouped = userColumns.find((column) => column.id === "Grouped" || column?.relatedId === "Grouped") ? true : false

  return (
    <React.Fragment>
      {showGlobalFilter ? (
        <Row className="float-end">
          <Col>
            <div className="d-flex justify-content-end mb-2">
              <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            </div>
          </Col>
        </Row>
      ) : (
        ""
      )}

      {showNavExtendedData ? (
        <div className='table-components d-flex justify-content-end navbar-splits'>
          {extendedComponents}
          <div className="p-2 ">
            {/* Check if is necesary show navbar(enought intermediate poinsts) */}
            {showNavExtendedDataInternal ? <NavbarSplits
              //show={showNavExtendedDataInternal}
              columnIndex={columnIndex}
              setColumnIndex={setColumnIndex}
              numColumns={userColumns.filter(cell => cell.isVisible === false && cell.columnIndex !== undefined).length}
              numExtendedColsVisible={numExtendedColsVisible}
              hasTimeline={hasTimeline}
              rscId={rscId}
            /> : ''}
          </div>
        </div>
      ) : ''}

      {/* <Row className='g-0'>
                <Col className={containerColumnClassName}> */}
      <div className={id !== "mirs-table-schedule-grid" ? "shadow-scrollbox" : ""}>
        <Table
          aria-live={showPagination ? "polite" : null}
          className={'mirs-table ' + className}
          id={id} discipline={discipline} {...(ariaLabelledby && { 'aria-labelledby': ariaLabelledby })}
          aria-describedby={(summaryDesc) ? 'table-desc-id' : null}
          {...getTableProps()}
        >
          {caption &&
            <caption className={classCaption}>
              {caption}
            </caption>
          }
          <thead className={theadClassName}>
            {
              /* Comprobamos que exista la columna KeyIndex necesaria para hacer los rowspan en el body, es por la columna que se mantendra ese orden dentro de un Rowspan*/
              headerGroups.map((headerGroup, i) => {
                if (!hasKeyIndex) {
                  //hasKeyIndex = headerGroup.headers.find((column) => column.id === "KeyIndex") ? true : false
                }
                if (!hasGrouped) {
                  hasGrouped = headerGroup.headers.find((column) => column.id === "Grouped") ? true : false
                }
              })
            }
            {headerGroups.map((headerGroup, i) => {
              return (
                <React.Fragment key={i + "_hfrag"}>
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {/* Filtramos con la propiedad sort de la columna para no mostrar la columna*/}
                    {/* No mostramos las cabeceras de la columna agrupada , Grouped*/}
                    {headerGroup.headers.filter(cell => cell.id !== 'Grouped').map((column, id) => {
                      const aux = column
                      /* Miramos que tiene related Id para saber que es de cabecera no un rowspan en el cuerpo*/
                      if (aux.enableRowSpan && aux.relatedId && headerGroups.length > 1) {
                        const col = headerGroups.length > 1 && headerGroups[1]?.headers.find(item => item.id === aux.relatedId)
                        column = col;
                        column.headerClassName = aux.headerClassName;
                        column.rowSpan = 2;
                      }

                      if (aux.remove) {
                        column.headerClassName = "d-none"
                      }


                      //Miramos de la columna Expanded si tiene la propiedad que se puede epandir (rowCanExpand)
                      const rowCanExpanded = column?.filteredRows?.some(dd => dd?.values?.Expander?.rowCanExpand);
                      if (column?.id === 'Expander' && !rowCanExpanded) {
                        let hiddenCols = [...hiddenColumns, 'Expander']
                        setHiddenColumns(hiddenCols)
                      }


                      let cAlign = '';
                      if (column?.headerClassName?.includes && column?.headerClassName?.includes("text-end")) {
                        cAlign = 'w-100 text-end';
                      }
                      if (column?.headerClassName?.includes && column?.headerClassName?.includes("text-center") && !column?.canSort) {
                        cAlign = 'w-100 text-center';
                        // cAlign = 'm-2 text-center';
                      }
                      if (column?.headerClassName?.includes && column?.headerClassName?.includes("text-start")) {
                        cAlign = 'w-100 text-start';
                        //cAlign = 'm-2 text-start';
                      }

                      let objCell = {
                        rowSpan: column.rowSpan,
                        key: column.id,
                        style: { ...column.style },
                        className: column.headerClassName,
                        mirsid: column.id
                      }
                      if (column.headerColSpan) {
                        objCell.colSpan = column.headerColSpan;
                      }


                      const getSortByToggleProps = () => {
                        // Simulating the getProps function from your library
                        return {
                          ...column.getHeaderProps([
                            objCell,
                            getColumnProps(column),
                            getHeaderProps(column),
                            !hasKeyIndex && !hasGrouped && column.getSortByToggleProps(),
                          ])
                        }
                      }

                      return (
                        <th aria-sort={column.isSorted ?
                          column?.isSortedDesc ? "descending" : "ascending"
                          : null
                        }{...getSortByToggleProps()}
                          onClick={(e) => {
                            /*
                            if (column.columnIndex && column.canSort) {
                                //Only if has colindex (Split columns)
                                //Change IntermediateSelector in Redux by index
                                let intermediateSelector = Object.assign({}, intermediateSelectorRedux);
                                intermediateSelector.selected = column.columnIndex;
                                intermediateSelector.isLive = false
                                dispatch(componentIntermediateSelector(intermediateSelector))
                            }
                            */
                            if (getSortByToggleProps().onClick) {
                              getSortByToggleProps().onClick(e);
                            }
                            if (sortCallBack) { sortCallBack(column.id, column.isSortedDesc) }
                            if (hasKeyIndex) {                                                      //Sort by default ascendig if is not defined, used in Rowspan
                              if (column.isSortedDesc === undefined) {
                                column.isSortedDesc = true;
                              }
                              column.canSort && setSortBy([{ id: column.id, desc: !column.isSortedDesc }, { id: 'KeyIndex', desc: false }])
                            }
                            if (column.canSort && column.multiSort && Array.isArray(column.multiSort)) {
                              if (!column?.multiSort[0].hasOwnProperty('desc')) {
                                column.multiSort[0]["desc"] = false;
                              }
                              if (column.isSortedDesc === undefined) {
                                column.isSortedDesc = !column?.multiSort[0].desc;
                              }
                              const desc = !column.isSortedDesc;
                              let result = column.multiSort.map(item => item.id === column.id ? { ...item, desc: desc } : item);
                              setSortBy(result)
                            }

                            if (hasGrouped) {                                                      //Sort by default ascendig if is not defined, used in Rowspan
                              column.canSort && setSortBy([{ id: 'Grouped', desc: false }, { id: column.id, desc: !column.isSortedDesc }])
                            }

                            if (!column.canSort) {
                              column.id === 'Expander' && handleClickAllExpanded(obj)
                            }
                            if (column.isSortedDesc) {

                            }
                          }
                          }

                        >
                          <HeaderType column={column}>
                            <span className={cAlign}>
                              {column.render("Header", { 'expandedAllElements': expandedAllElements })}
                            </span>
                            {column.canSort ? (
                              <span className="svg-mirs align-self-center">
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <SvgMirs className='mirsIcon' ariaHidden={true} code='arrow-down' />
                                  ) : (
                                    <SvgMirs className='mirsIcon' ariaHidden={true} code='arrow-up' />
                                  )

                                ) : (
                                  <SvgMirs className='mirsIcon' ariaHidden={true} code='arrows-up-down' titleIsText={true} />
                                )}
                              </span>
                            ) : ''}
                          </HeaderType>

                          {/*
                                                            <div
                                                                {...column.getResizerProps()}
                                                                className="resizer"
                                                            />
                                                            {
                                                                column.canResize && (
                                                                    <div
                                                                        {...column.getResizerProps()}
                                                                        className={`resizer ${column.isResizing ? "isResizing" : ""}`}
                                                                    />
                                                                )
                                                            }
                                                            

                                                            < div >
                                                                {column.canFilter ? column.render("Filter") : null}
                                                            </div>
                                                            */}
                        </th>
                      )

                    })}
                  </tr>
                </React.Fragment>
              )
            })}
          </thead>
          <tbody {...getTableBodyProps()} className={tbodyClassName}>

            {obj.map((row, i) => {
              prepareRow(row);
              const rowId = getJsonData(keyRow, i, row) !== undefined ? getJsonData(keyRow, i, row) : keyRow + '_' + i
              const splitElement = rowId.split('~')
              let idElement
              if (splitElement.length > 1) { idElement = splitElement[0] }

              //  let rowCanExpanded = false;
              for (let j = 0; j < row.allCells.length; j++) {
                let cell = row.allCells[j];
                let rowSpanHeader = rowSpanHeaders.find(
                  x => x.id === cell.column.id
                );

                if (rowSpanHeader !== undefined) {
                  let props = {}
                  props["cell"] = {}
                  props["cell"]["row"] = {}
                  props["cell"]["row"]["original"] = row.original

                  //MAke Rowspan by 
                  // accesor: CellValue  
                  // rowid: by id element most cases athlete-code with expanded send key athlete-code-rowNum (get only athlete-code)  
                  let cellValue = (typeof cell.value === 'object')
                    ? cell.value.rowSpanId
                    : cell.column.rowSpanType === 'accessor' ? cell.value
                      : cell.column.rowSpanType === 'rowid' ? idElement : cell.column.Cell(props);
                  if (
                    rowSpanHeader.topCellValue === null ||
                    rowSpanHeader.topCellValue !== cellValue
                  ) {
                    if (typeof cell.value === 'object') {
                      rowSpanHeader.topCellValue = cell.value.rowSpanId;
                    } else {
                      rowSpanHeader.topCellValue = cellValue
                    }
                    cell.isRowSpanned = false;
                    rowSpanHeader.topCellIndex = i;
                    cell.rowSpan = 1;
                    indexMainRow = i;
                    cell.indexMainRow = i;
                  } else {
                    obj[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                    cell.isRowSpanned = true;
                    cell.indexMainRow = indexMainRow;
                  }
                }

                //miramos si tiene elemento s a mostrar para poder expandirse 
                //sino siempre hara un expand cuando hagamos un expand all y mostrarauna fila vacia 
                //o con el componente cuando no tiene el icono indicativo
                if (cell.column.id === 'Expander') {
                  row.rowCanExpanded = !!cell.value.rowCanExpand
                }
              }
              return null;
            })}


            {obj.map((row, i) => {

              const rowId = getJsonData(keyRow, i, row) !== undefined ? getJsonData(keyRow, i, row) : keyRow + '_' + i
              const split = rowId.split('~')
              const cell = row.cells.find(cell => cell.column.id === 'Expander')
              let element
              if (split.length > 1) {
                element = split[0] + "~" + cell?.rowSpan
              } else {
                element = split[0]
              }
              if (row.rowCanExpanded && expandedElements.includes(element)) {
                row.isExpanded = true
              } else {
                row.isExpanded = false

              }
              const cellGrouped = row.cells.find(cell => cell.column.id === 'Grouped')
              const groupedCode = cellGrouped?.value
              const isGrouped = groupedCode !== lastGrouped

              if (isGrouped) {
                lastGrouped = groupedCode
              }

              let objPropertiesRow = { ...row.getRowProps(getRowProps(row)) }
              if (hasKeyIndex) {
                if (row?.values?.KeyIndex === '1') { rowBlockId++; }
              } else {
                rowBlockId = i;
              }
              objPropertiesRow.className = `${objPropertiesRow.className ? objPropertiesRow.className + ' ' : ''}${isOdd(rowBlockId) ? "tr-odd" : "tr-even"}`
              return (
                <React.Fragment key={rowId}>
                  {hasGrouped && isGrouped &&
                    <tr>
                      <td colSpan={row.cells.length - 1} className={cellGrouped.column.className}>
                        {cellGrouped?.render("Cell")}
                      </td>
                    </tr>
                  }

                  <tr data-key={getJsonData(keyRow, i, row) + "_row"}
                    {...objPropertiesRow}
                    // style={{ cursor:rowOnClick===true ? 'pointer' : 'default' }}
                    onClick={
                      rowOnClick
                        ? () => rowClickHandler(row.original)
                        : () => ""
                    }
                  >
                    {row.cells.filter(c => c.column.id !== 'Grouped').map((cell) => {
                      if (cell.isRowSpanned)
                        return null;
                      else
                        return (
                          <td {...cell.getCellProps([
                            {
                              rowSpan: cell.rowSpan,
                              className: cell.column.className,
                              style: cell.column.style
                            },
                            getColumnProps(cell.column),
                            getCellProps(cell)
                          ])}
                            onClick={() => cell.column.id === 'Expander' ? handleClickExpanded(rowId, cell, obj) : ''}

                          >
                            {cell.render("Cell")}
                          </td>
                        );
                    })}
                  </tr>
                  {/* {row.rowCanExpanded && rowId === '1340888' ? ( */}
                  {/*row.isExpanded && row.rowCanExpanded ? (*/}
                  {/*row.rowCanExpanded && expandedElements.includes(rowId) ? (*/}

                  {/*
                                        Cases team - athletes
                                        indexMainRow row index to related group rows (rowspan , the first row due to in expecial cases is the row for team)
                                        in other cases is the same, all rows can have the information necesary in expanded
                                        */}

                  {row.rowCanExpanded && expandedElements.includes(rowId) ? (
                    <>
                      < tr data-key={getJsonData(keyRow, i, row) + "_expanded"} className="tr-expanded" >
                        <td className="mirs-expander" colSpan={row.cells.length}>
                          {renderRowSubComponent({ row: obj[cell?.indexMainRow] })}
                        </td>
                      </tr>
                    </>
                  ) : null}
                </React.Fragment>
              );
            })}
          </tbody>
          {footerData && (
            <tfoot>
              {headerGroups.map((headerGroup, i) => {
                if (headerGroup.headers.length > 2) {
                  return (
                    <tr key={i + "_footer"}>
                      {headerGroup.headers.map((column, id) => (
                        <td
                          key={column.id + "_footer"}
                          className={id === 0 ? "" : "text-center"} // Remove className for the first column
                        >
                          {renderFooterCellContent(column)}
                        </td>
                      ))}
                    </tr>
                  );
                }
                return null; // Return null for cases where headers.length <= 2
              })
              }
            </tfoot>)}
        </Table>
        {(summaryDesc !== undefined) && <span id="table-desc-id" style={{ display: 'none' }}>{summaryDesc}</span>}
      </div>

      {/**  INICIO Pagination */}
      {showPagination ? (
        <PaginationTable canPreviousPage={canPreviousPage} canNextPage={canNextPage} pageIndex={pageIndex} pageOptions={pageOptions} gotoPage={gotoPage} previousPage={previousPage} pageSize={pageSize} setPageSize={setPageSize} rows={rows} nextPage={nextPage} pageCount={pageCount} breakPoint={breakPoint} />
      ) : (
        ""
      )
      }

      {/*                 </Col>
            </Row > */}
    </React.Fragment >
  );
};

MirsTable.defaultProps = {
  rowOnClick: false,
  showNavExtendedData: false,
  //expandRows: false,
  //expandedRowObj: {},
  hiddenColumns: [],
  initialSortBy: [{ id: 'Rank', desc: false }],
  pageSizeCustom: 50,
  showPagination: false,
  data: []

};

MirsTable.propTypes = {

  /** Specifies if there should be a row onClick action*/
  rowOnClick: PropTypes.bool.isRequired,

  /** OPTIONAL: The onClick Action to be taken */
  rowClickHandler: PropTypes.func,

  /** header color background. There are six possible choices. Refer to ReadMe file for specifics */
  headerColor: PropTypes.string,

  /** Specified if pagination should show or not */
  showPagination: PropTypes.bool.isRequired,

};


export function isOdd(num) {
  if (num % 2 === 0) {
    return true; // es par
  }
  else {
    return false; // es impar
  }
}

function HeaderType({ children, column }) {
  const canSort = column.canSort
  const isExpander = column.id === 'Expander'


  if (canSort) {
    let cAlign = "d-flex w-100 sortable"
    if (column?.headerClassName && column?.headerClassName?.includes("text-center")) {
      cAlign = "d-flex w-100 sortable justify-content-center"
    }

    if (column?.headerClassName && column?.headerClassName?.includes("text-end")) {
      cAlign = "d-flex w-100 sortable justify-content-end"
    }


    return (
      <button className={cAlign}  >
        {children}
      </button>
    )
  } else if (isExpander) {
    return (children)
  } else {
    return (
      <div className="d-flex">
        {children}
      </div>
    )
  }
}

export default MirsTable;


function PaginationTable({ canPreviousPage, canNextPage, pageIndex, pageOptions, gotoPage, previousPage, pageSize, setPageSize, rows, nextPage, pageCount, breakPoint }) {
  const [PageNum, setPageNum] = useState(0)
  const fLabel = useLabels()
  const isMobile = breakPoint === "sm" || breakPoint === "xs"
  const isTablet = breakPoint === "md"

  let leftPart = <div className="mirs-pagination-left">
    {!isMobile && <Button
      className="me-2 "
      size="sm"
      variant="secondary"
      onClick={() => gotoPage(0)}
      disabled={!canPreviousPage}
      aria-label={fLabel({ data: "HeaderGoToFirstPage" })}
    >
      <SvgMirs className='mirsIcon' code='doble-left' insideBtn={true} />
    </Button>}

    <Button
      className="me-2"
      size="sm"
      variant="secondary"
      onClick={() => previousPage()}
      disabled={!canPreviousPage}
      aria-label={fLabel({ data: "HeaderPreviousPage" })}
    >
      <SvgMirs className='mirsIcon' code='arrowLeft' insideBtn={true} />
    </Button>

    <span className="pe-3">
      <Label data="page-of" values={{ page: pageIndex + 1, pageTotal: pageOptions.length }} ></Label>
    </span>
  </div>

  let centerPart = <div className="mirs-pagination-center d-flex flex-row">

    {/*
    <Button
      id="btnGotoPage"
      className="me-2"
      size="sm"
      variant="secondary"
      onClick={() => gotoPage(PageNum)}
      //disabled={!canPreviousPage}
      aria-label={fLabel({ data: "GoToPage" })}
    >
      <label htmlFor="goToPage">
        <Label data="GoToPage" />
      </label>
    </Button>
  */}
    <span className="pe-3" >
      <label htmlFor="goToPage">
        | <Label data="GoToPage" />
      </label>
    </span>


    <span className="pe-3">
      <InputGroup size="sm" >
        <FormControl
          type="number"
          id="goToPage"
          defaultValue={pageIndex + 1}
          onChange={(e) => {
            let page = e.target.value
              ? Number(e.target.value) - 1
              : 0;

            if (page < 1) {
              e.target.value = 1;
              page = 0;
            }
            if (page > pageOptions.length - 1) {
              e.target.value = pageOptions.length;
              page = pageOptions.length;

            }

            setPageNum(page)
            gotoPage(page)
          }}


        />
      </InputGroup>
    </span>
    <span className="pe-3">
      <label htmlFor="pageSize" className="sr-only">Elements per page</label>
      <InputGroup size="sm">
        <FormControl
          id="pageSize"
          size="sm"
          as="select"
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 25, 50, 75, 100].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {<Label data='LabelShow' />} {pageSize}
            </option>
          ))}
        </FormControl>
      </InputGroup>
    </span>

  </div>

  let rightPart = <div className="mirs-pagination-right">
    <span className="pe-3">{rows.length} <Label data="Elements" /></span>
    <Button
      className="me-2"
      size="sm"
      variant="secondary"
      onClick={() => nextPage()}
      disabled={!canNextPage}
      aria-label={fLabel({ data: "HeaderNextPage" })}
    >
      <SvgMirs className='mirsIcon' code='arrowRight' insideBtn={true} />
    </Button>
    {!isMobile && <Button
      className="me-2"
      size="sm"
      variant="secondary"
      onClick={() => gotoPage(pageCount - 1)}
      disabled={!canNextPage}
      aria-label={fLabel({ data: "HeaderGoToLastPage" })}
    >
      <SvgMirs className='mirsIcon' code='doble-right' insideBtn={true} />
    </Button>}
  </div>


  let out
  if (isMobile || isTablet) {
    out = <>
      <div className="container d-flex flex-row   justify-content-center mb-4">
        {leftPart}{rightPart}
      </div>
      <div className="container d-flex flex-row mirs-pagination justify-content-center">
        {centerPart}
      </div>
    </>
  } else {
    out = <div className="container d-flex flex-row mirs-pagination justify-content-center">
      {leftPart}{centerPart} {rightPart}
    </div>

  }
  return (out)
}